module.exports = __webpack_public_path__ + "img/logo.b2f038c9.png";